import React from "react";
import { LoadOverlay, Spinner, LoadText } from "./styled";

const Load = () => {
  return (
    <LoadOverlay role="status" aria-label="Carregando">
      <Spinner />
      <LoadText>Carregando...</LoadText>
    </LoadOverlay>
  );
};

export default Load;
